export const IMAGE_MAX_SIZE = 2097152;
export const IMAGE_ACCEPT_TYPE = 'image/jpeg';
